import type { ProgramEventListType } from 'models';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useEventRsvpLabels } from './useEventRsvpLabels';

export const useGetParticipantsCountLabel = ({ eventType }: { eventType: ProgramEventListType }) => {
  const { getInviteesAcceptedLabel } = useEventRsvpLabels();
  const { t } = useTranslation();

  return useCallback(
    (formattedCount: string) => {
      if (eventType === 'reminder') {
        return t('{{count}} people', { count: formattedCount });
      }

      return getInviteesAcceptedLabel({ formattedInvitees: formattedCount });
    },
    [eventType, getInviteesAcceptedLabel, t],
  );
};
